module.exports = [{"filename":"About","displayName":"About us"},{"filename":"BlogPost","displayName":"Blog post"},{"filename":"DocsPost","displayName":"Docs"},{"filename":"LeadGen","displayName":"Lead Gen"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/templates.json
// module id = soXp
// module chunks = 6